import { getUser } from "@synthesis/shared-auth";
import { setApiBaseUrl, setAuthTokenGetter } from "@synthesis/shared-services";

import { uriPrefix } from "./axios-instance";

export const configureServices = (): void => {
  if (typeof uriPrefix === "string") {
    setApiBaseUrl(uriPrefix);
  }
  setAuthTokenGetter(() => getUser()?.access_token);
};
